import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

export default function initIntroSlider() {
    const swiper = new Swiper('.intro-slider', {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}

// Initialize on page load
window.addEventListener('load', initIntroSlider);
